import React, { useEffect, useState, useMemo } from "react";
import { useFileContext } from "../../../../Contexts/FileContext";
import ssoImg1 from "./../../../../assets/images/checklists-form-img.png";
import pdfIcon from "./../../../../assets/images/pdf.png";
import { WebApiURL } from "../../../../Constants/Constants";
import close from "./../../../../assets/images/closeicon.jpeg";
import CryptoJS from "crypto-js";
import { encryptFileIdValue } from "../../../../utils/encryption";

function FormsAllFormsTab() {
  const {
    setComponentName,
    documents,
    loading,
    allDocuments
  } = useFileContext();

  const [searchTerm, setSearchTerm] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const encodeBase64 = (str) => btoa(unescape(encodeURIComponent(str)));


  const secretKey = "MySAMSASecretKey2025"; // same as backend

  const encryptFileId = (fileId) => {
    const ciphertext = CryptoJS.AES.encrypt(fileId.toString(), secretKey).toString();
    return encodeURIComponent(ciphertext);
  };


  useEffect(() => {
    setComponentName("ALL FORMS");
  }, [setComponentName]);

  const filteredDocs =
    searchQuery.trim().length >= 3
      ? allDocuments.filter((doc) => {
        const lowerSearch = searchQuery.toLowerCase();
        const fileNameMatch = doc.fileName?.toLowerCase().includes(lowerSearch);
        const pageMatch =
          (doc.page ?? "").toString().toLowerCase() === "services";
        return fileNameMatch && pageMatch;
      })
      : [];
  const handleClear = () => {
    setSearchQuery("");
    setSearchTerm("");
  };
  const handleSearch = () => {
    setSearchQuery(searchTerm);
  }
  const groupedDocs = useMemo(() => {
    return filteredDocs?.reduce((acc, doc) => {
      const folder = doc.folderName || "Uncategorized";
      if (!acc[folder]) acc[folder] = [];
      acc[folder].push(doc);
      return acc;
    }, {});
  }, [filteredDocs]);

  // Sections for when not searching
  const sections = useMemo(() => {
    const sectionSet = new Set();
    documents?.forEach((doc) => {
      const section = typeof doc?.section === "string" ? doc.section.trim() : "";
      if (section) sectionSet.add(section);
    });
    return Array.from(sectionSet);
  }, [documents]);


  const renderDocumentsBySection = (sectionName) => {
    const docs = documents?.filter(
      (doc) =>
        String(doc?.section || "").trim().toLowerCase() ===
        String(sectionName || "").trim().toLowerCase()
    );
    const grouped = docs?.reduce((acc, doc) => {
      const folder = doc?.folderName || doc?.section || "Uncategorized";
      if (!acc[folder]) acc[folder] = [];
      acc[folder].push(doc);
      return acc;
    }, {});

    return (
      <ul className="strip-ul">
        {Object.entries(grouped).map(([folderName, folderDocs], idx) => (
          <li key={idx}>
            <div className="row g-4">
              <div className="col-auto">
                <img style={{ width: "40px" }} src={pdfIcon} alt="PDF icon" />
              </div>
              <div className="col">
                <div className="row g-4">
                  <div className="col-md">
                    <div className="font-18 font-600">File Name</div>
                    <div className="font-16 font-400">
                      <p className="text-orange-ef3e33 text-uppercase">
                        {folderName}
                      </p>
                      <ul className="list">
                        {folderDocs.map((doc, i) => (
                          <li key={i}>

                            <a
                              href={`${WebApiURL}File/view/${encryptFileIdValue(doc.fileId)}`}
                              // target="_blank"
                              rel="noopener noreferrer"
                            >
                              {doc.fileName}
                            </a>
                          </li>
                        ))}
                      </ul>



                    </div>
                  </div>

                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        FORMS <span className="text-orange-ef3e33 font-400">ALL FORMS</span>
      </div>

      <div className="row g-3 g-sm-4 g-md-4">
        <div className="col-lg-7">
          <p className="text-primary-color mb-3">
            PLEASE NOTE: “Should the form show a ‘Please Wait…’ ERROR MESSAGE,
            save/download the form to your device (desktop, laptop or phone) and
            open the form from there and not via your web browser.”
          </p>
        </div>

        {/* Search bar */}
        <div className="col-12">
          <div className="checklists-form-wrap">
            <div className="checklists-form">
              <div className="checklists-form-img">
                <img src={ssoImg1} alt="" />
              </div>
              <div className="checklists-form-field">
                <div className="font-17 font-600 mb-1 text-white">
                  Search for forms, checklists or check sheets
                </div>
                <div className="row g-3 flex-column flex-sm-row">
                  <div className="col">
                    <div className="search-block">
                      <input type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="form-control height-50 border-0 rounded-0"
                        placeholder="type your information here" />
                      {searchTerm.length >= 1 &&
                        <button type="button" className="btn btn-close">
                          <img src={close} alt="" className="" onClick={handleClear} /></button>}
                    </div>
                  </div>
                  <div className="col-auto">
                    <button
                      type="button"
                      className="btn btn-submit height-50 rounded-0"
                      onClick={handleSearch}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Results */}
        <div className="col-12">
          {loading ? (
            <div>Loading documents...</div>
          ) : searchQuery.trim().length >= 3 ? (
            filteredDocs.length === 0 ? (
              <div>No search results found. Please try again.</div>
            ) : (
              <ul className="strip-ul mt-3">
                {Object.entries(groupedDocs).map(([folderName, docs], index) => (
                  <li className="bg-transparent p-0" key={index}>
                    <div className="row g-4">
                      <div className="col-auto">
                        <img style={{ width: "40px" }} src={pdfIcon} alt="PDF icon" />
                      </div>
                      <div className="col">
                        <div className="row g-4">
                          <div className="col-md">
                            <div className="font-18 font-600">File Name</div>
                            <div className="font-16 font-400">
                              <p className="text-orange-ef3e33 text-uppercase">
                                {folderName}
                              </p>
                              <ul className="list">
                                {docs.map((item, i) => (
                                  <li key={i}>

                                    {/* <a
                                      href={`${WebApiURL}File/view/${encodeURIComponent(item.fileId)}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    > */}
                                    <a
                                      // href={`${WebApiURL}File/view/${encodeBase64(item.fileId.toString())}`}
                                      href={`${WebApiURL}File/view/${encryptFileId(item.fileId)}`}
                                      // target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item.fileName}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                          <div className="col-md-auto">
                            <div className="font-18 font-600">Modified</div>
                            <div className="font-16 font-400">
                              {docs[0]?.modifiedDate
                                ? new Date(docs[0].modifiedDate).toLocaleString()
                                : "—"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            )
          ) :
            // <></>
            /* 
             TOGGLE FEATURE:
            Uncomment the below block and comment above block if you want to display documents
            grouped by section even before the user performs a search.
            Keep it commented if you want this tab to be SEARCH-ONLY.
          */
            (
              <div className="accordion blackTab" id="blackTab">
                {sections?.map((sectionName, idx) => (
                  <div className="accordion-item" key={sectionName}>
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${activeIndex !== idx ? "collapsed" : ""}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#section-${idx}`}
                        aria-expanded={idx === 0 ? "true" : "false"}
                        aria-controls={`section-${idx}`}
                        onClick={() => setActiveIndex(idx)}
                      >
                        {sectionName}
                      </button>
                    </h2>
                    <div
                      id={`section-${idx}`}
                      className={`accordion-collapse collapse ${activeIndex === idx ? "show" : ""}`}
                      data-bs-parent="#blackTab"
                    >
                      <div className="accordion-body px-0">
                        {loading ? (
                          <div>Loading documents...</div>
                        ) : (
                          renderDocumentsBySection(sectionName)
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )
          }
        </div>
      </div>
    </>
  );
}

export default FormsAllFormsTab;
